module.exports = __webpack_public_path__ + "static/img/1-1.c283c35.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/1-1.png
// module id = cakn
// module chunks = 0